// extracted by mini-css-extract-plugin
module.exports = {"resources":"links_resources__M5QZ2"};